import Vue from "vue";
import Router from "vue-router";
import global from "../assets/js/global.js";
Vue.use(Router);

// 添加这下面一段代码，就可以解决报错
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)}
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "mainIndex",
      redirect: (to) => {
        let userAgentInfo = navigator.userAgent;
        let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        let flag = true;
        if (userAgentInfo.indexOf("iPhone") >= 0) {
          localStorage.setItem("userPhone", "iPhone");
        } else if (userAgentInfo.indexOf("Android") >= 0) {
          localStorage.setItem("userPhone", "Android");
        } else {
          localStorage.setItem("userPhone", "Android");
        }
        for (let v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) >= 0) {
            flag = false;
            break;
          }
        }
        return {
          name: flag ? "Login" : "DownloadApp",
        };
      },
    },
    {
      path: "/login",
      name: "Login",
      component: (resolve) => {
        const hostname = window.location.hostname;
        if (global.jll.some((item) => hostname.includes(item))) {
          return require(["@/components/jll/Login.vue"], resolve);
        } else {
          return require(["@/components/Login.vue"], resolve);
        }
      },
    },
    {
      path: "/toDownloadApp",
      name: "ToDownloadApp",
      component: (resolve) => require(["@/components/ToDownloadAppPage.vue"], resolve),
    },
    {
      path: "/DownloadApp",
      name: "DownloadApp",
      component: (resolve) => require(["@/components/DownloadApp.vue"], resolve),
    },
    {
      path: "/forgotPassword",
      name: "forgotPassword",
      component: (resolve) => {
        const hostname = window.location.hostname;
        if (global.jll.some((item) => hostname.includes(item))) {
          return require(["@/components/jll/ForgotPassword.vue"], resolve);
        } else {
          return require(["@/components/ForgotPassword.vue"], resolve);
        }
      },
    },
    {
      path: "/resetPassword",
      name: "resetPassword",
      component: (resolve) => {
        const hostname = window.location.hostname;
        if (global.jll.some((item) => hostname.includes(item))) {
          return require(["@/components/jll/ResetPassword.vue"], resolve);
        } else {
          return require(["@/components/ResetPassword.vue"], resolve);
        }
      },
    },
    {
      path: "/changePassword",
      name: "ChangePassword",
      component: (resolve) => {
        const hostname = window.location.hostname;
        if (global.jll.some((item) => hostname.includes(item))) {
          return require(["@/components/jll/ChangePassword.vue"], resolve);
        } else {
          return require(["@/components/ChangePassword.vue"], resolve);
        }
      },
    },
    {
      path: "/replaceLogin",
      name: "ReplaceLogin",
      component: (resolve) => require(["@/components/ReplaceLogin.vue"], resolve),
    },
    {
      path: "/downloadVerify",
      name: "DownloadVerify",
      component: (resolve) => require(["@/components/DownloadVerify.vue"], resolve),
    },
    {
      path: "/lead_qr_form",
      name: "Lead QR Form Capture",
      component: (resolve) => require(["@/components/project_manage/projectDetails/LeadQRForm.vue"], resolve),
    },
    {
      path: "/bind-gmail",
      name: "BindGmail",
      component: (resolve) => require(["@/components/BindGmail.vue"], resolve),
    },
    {
      path: "/bind-outlook",
      name: "BindOutlook",
      component: (resolve) => require(["@/components/BindOutlook.vue"], resolve),
    },
    {
      path: "/lead_capture_form",
      name: "Lead Capture Form",
      component: (resolve) => require(["@/components/project_manage/projectDetails/LeadCaptureForm.vue"], resolve),
    },
    {
      path: "/sign-sales-doc",
      name: "SignSalesDoc",
      meta: { Auth: true },
      component: (resolve) => require(["@/components/SalesSign.vue"], resolve),
    },
    {
      path: "/index",
      name: "index",
      // 添加 meta 字段，表示进入这个路由是需要登录的
      meta: { Auth: true },
      component: (resolve) => require(["@/components/Index"], resolve),
      redirect: "/dashboard",
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { Auth: true, breadNumber: 0 },
          component: (resolve) => require(["@/components/dashboard/Dashboard.vue"], resolve),
        },
        {
          path: "/dashboard/allVisitList",
          name: "latest_access_via_agent_app",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/dashboard/AllVisitList.vue"], resolve),
        },
        {
          path: "/master_manage/statsDashboard",
          name: "statsdashboard",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) =>
            require(["@/components/master_manage/dashboard_statistic/StatisticDashboard.vue"], resolve),
        },
        //############### 项目管理 开始 ###############
        {
          path: "/project_manage/tagsView",
          name: "tags_project",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/TagsView.vue"], resolve),
        },
        {
          path: "/project_manage/addProject",
          name: "add_new_project",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/AddProject.vue"], resolve),
        },
        {
          path: "/project_manage/addNewSingleListing",
          name: "add_new_single_listing",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/NewSingleListing.vue"], resolve),
        },
        {
          path: "/project_manage/allProjects",
          name: "all_projects_listings",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/project_manage/AllProjects.vue"], resolve),
          redirect: "/project_manage/allProjects/AllSelling",
          children: [
            {
              path: "/project_manage/allProjects/AllSelling",
              name: "all_listings",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/project_manage/ActiveProjects.vue"], resolve),
            },
            {
              path: "/project_manage/allProjects/Approvals",
              name: "project_approvals",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/project_manage/Approvals.vue"], resolve),
            },
            {
              path: "/project_manage/allProjects/Deactivated",
              name: "deactivated",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/project_manage/InActiveProjects.vue"], resolve),
            },
            {
              path: "/project_manage/allProjects/SharedByAgency",
              name: "shared_by_agency",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/project_manage/SharedByAgency.vue"], resolve),
            },
            {
              path: "/project_manage/allProjects/SharedByOthers",
              name: "shared_by_others",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/project_manage/SharedByOthers.vue"], resolve),
            },
            {
              path: "/project_manage/allProjects/SharedListings",
              name: "shared_listings",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/project_manage/SharedListings.vue"], resolve),
            },
          ],
        },
        {
          path: "/project_manage/allProjects/listingApprovalPage/:id",
          name: "listing_approval_page",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/ListingApprovalPage.vue"], resolve),
        },
        {
          path: "/project_manage/allProjects/sharedApprovalPage/:id",
          name: "shared_approval_page",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/SharedApprovalPage.vue"], resolve),
        },
        {
          path: "/project_manage/ProjectDetail",
          name: "project_manage",
          component: (resolve) => require(["@/components/project_manage/ProjectDetail.vue"], resolve),
          redirect: "/project_manage/projectInfo",
          meta: { Auth: true, breadNumber: 1 },
          children: [
            {
              path: "/project_manage/projectDetails/projectInfo/:id",
              name: "project_info",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/projectInfo.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/properties/:id",
              name: "properties",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/properties.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/teams/:id",
              name: "teams",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/teams.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/leads/:id",
              name: "leads",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/leads.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/sales_report/:id",
              name: "sales_report",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/salesReport.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/property_log/:id",
              name: "property_log",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/propertyLog.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/pricelist_pdf/:id",
              name: "pricelist_pdf",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/projectDetails/priceListPdf.vue"], resolve),
            },
            {
              path: "/project_manage/projectDetails/display_mode/:id",
              name: "display_mode",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) =>
                require(["@/components/project_manage/projectDetails/projectDisplay.vue"], resolve),
            },
          ],
        },
        {
          path: "/project_manage/saleAdvice",
          name: "sales_advice",
          meta: { Auth: true, breadNumber: 3 },
          component: (resolve) => require(["@/components/sale_manage/SaleAdvice.vue"], resolve),
        },
        {
          path: "/project_manage/saleFinish/:id",
          name: "sales_advice",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/sale_manage/SaleFinish.vue"], resolve),
        },
        {
          path: "/project_manage/editProject/:id",
          name: "edit_project",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/edit_project/EditProject.vue"], resolve),
          redirect: "/project_manage/edit_project/baseInformation/:id",
          children: [
            {
              path: "/project_manage/edit_project/baseInformation/:id/",
              name: "base_information",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) =>
                require(["@/components/project_manage/edit_project/BaseInformation.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/displayInformation/:id",
              name: "display_and_inspection",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) =>
                require(["@/components/project_manage/edit_project/DisplayInformation.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/commissionRate/:id",
              name: "commission_rate",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/CommissionRate.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/projectContacts/:id",
              name: "project_contacts",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) =>
                require(["@/components/project_manage/edit_project/ProjectContacts.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/pictures/:id",
              name: "pictures",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Pictures.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/edmPictures/:id",
              name: "edm_content",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/EdmPictures.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/attachments/:id",
              name: "attachments",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Attachments.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/shareTo/:id",
              name: "sharing",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/ShareTo.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/outsideLink/:id",
              name: "outside_link",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/OutsideLink.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/variations/:id",
              name: "variations",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Variations.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/properties/:id",
              name: "properties",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Properties.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/saleAdvice",
              name: "sales_advice",
              meta: { Auth: true, breadNumber: 4 }, //这里面包屑为什么是4
              component: (resolve) => require(["@/components/sale_manage/SaleAdvice.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/agreements/:id",
              name: "agreements",
              meta: { Auth: true, breadNumber: 3 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Agreements.vue"], resolve),
            },
          ],
        },
        {
          path: "/project_manage/projectDetail/propertyDetail/:id",
          name: "property_detail",
          meta: { Auth: true, breadNumber: 3 },
          component: (resolve) => require(["@/components/project_manage/edit_project/PropertyDetail.vue"], resolve),
        },
        {
          path: "/project_manage/projectDetail/propertyView/:id",
          name: "property_detail",
          meta: { Auth: true, breadNumber: 3 },
          component: (resolve) => require(["@/components/project_manage/edit_project/PropertyView.vue"], resolve),
        },
        {
          path: "/project_manage/edit_project/propertyDetail/:id",
          name: "property_detail",
          meta: { Auth: true, breadNumber: 4 },
          component: (resolve) => require(["@/components/project_manage/edit_project/PropertyDetail.vue"], resolve),
        },
        {
          path: "/project_manage/projectSharesRecord",
          name: "project_shares_record",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/project_manage/ProjectSharesRecord.vue"], resolve),
        },
        {
          path: "/project_manage/projectViewsRecord",
          name: "project_views_record",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/project_manage/ProjectViewsRecord.vue"], resolve),
        },
        {
          path: "/project_manage/edit_project/propertyView/:id",
          name: "property_detail",
          meta: { Auth: true, breadNumber: 4 },
          component: (resolve) => require(["@/components/project_manage/edit_project/PropertyView.vue"], resolve),
        },
        {
          path: "/project_manage/allProjects2",
          name: "active_projects",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/project_manage/AllProjects2.vue"], resolve),
        },
        {
          path: "/project_manage/sharedProjects",
          name: "shared_projects",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/project_manage/SharedProjects.vue"], resolve),
        },
        {
          path: "/project_manage/sharedProjects/shareToChannel/:id",
          name: "share_to_channel",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/ShareToChannel.vue"], resolve),
        },
        {
          path: "/project_manage/sharedProjects/sharedCommissionRate",
          name: "shared_project_commission_rate",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/SharedCommissionRate.vue"], resolve),
        },
        {
          path: "/project_manage/allProperties",
          name: "all_properties",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/project_manage/AllProperties.vue"], resolve),
        },
        {
          path: "/project_manage/projectActivities",
          name: "project_activities",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/project_manage/ProjectActivities.vue"], resolve),
        },
        {
          path: "/project_manage/allProperties/propertyDetail/:id",
          name: "property_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/edit_project/PropertyDetail.vue"], resolve),
        },
        {
          path: "/project_manage/allProperties/propertyView/:id",
          name: "property_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/edit_project/PropertyView.vue"], resolve),
        },
        {
          path: "/project_manage/platform_manage/importExternalID",
          name: "import_externalid",
          meta: { Auth: true },
          component: (resolve) =>
            require(["@/components/project_manage/platform_manage/ImportExternalID.vue"], resolve),
        },
        {
          path: "/project_manage/platform_manage/agencyProject",
          name: "agency_project",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/project_manage/platform_manage/AgencyProject.vue"], resolve),
        },
        {
          path: "/project_manage/platform_manage/allProjects",
          name: "all_projects",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/project_manage/platform_manage/AllProjects.vue"], resolve),
        },
        {
          path: "/project_manage/platform_manage/allProjects/viewSharing/:id",
          name: "view_sharing",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/project_manage/platform_manage/ViewSharing.vue"], resolve),
        },
        {
          path: "/project_manage/platform_manage/allProjects/:id",
          name: "edit_project",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/project_manage/edit_project/EditProject.vue"], resolve),
          redirect: "/project_manage/platform_manage/allProjects/baseInformation/:id",
          children: [
            {
              path: "/project_manage/platform_manage/allProjects/baseInformation/:id",
              name: "base_information",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) =>
                require(["@/components/project_manage/edit_project/BaseInformation.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/displayInformation/:id",
              name: "display_information",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) =>
                require(["@/components/project_manage/edit_project/DisplayInformation.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/commissionRate/:id",
              name: "commission_rate",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/CommissionRate.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/keyContacts/:id",
              name: "key_contacts",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/KeyContacts.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/pictures/:id",
              name: "pictures",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Pictures.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/edmPictures/:id",
              name: "edm_content",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/EdmPictures.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/attachments/:id",
              name: "attachments",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Attachments.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/outsideLink/:id",
              name: "outside_link",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/OutsideLink.vue"], resolve),
            },
            {
              path: "/project_manage/platform_manage/allProjects/properties/:id",
              name: "properties",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Properties.vue"], resolve),
            },
            {
              path: "/project_manage/edit_project/agreements/:id",
              name: "agreements",
              meta: { Auth: true, breadNumber: 2 },
              component: (resolve) => require(["@/components/project_manage/edit_project/Agreements.vue"], resolve),
            },
          ],
        },
        {
          path: "/project_manage/platform_manage/approveSingleListings",
          name: "single_listing_approve",
          meta: { Auth: true },
          component: (resolve) =>
            require(["@/components/project_manage/platform_manage/ApproveSingleListings.vue"], resolve),
        },
        //############### 项目管理 结束 ###############
        //############### Marketplace 开始 ###############
        {
          path: "/marketplace",
          name: "marketplace",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/marketplace/Marketplace.vue"], resolve),
          redirect: "/marketplace/marketplaceMap",
          children: [
            {
              path: "/marketplace/marketplaceList",
              name: "open_marketplace",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/marketplace/MarketplaceList.vue"], resolve),
            },
            {
              path: "/marketplace/marketplaceMap",
              name: "open_marketplace",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/marketplace/MarketplaceMap.vue"], resolve),
            },
            {
              path: "/marketplace/manageMarketplace",
              name: "my_marketplace",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/marketplace/ManageMarketplace.vue"], resolve),
              redirect: "/marketplace/manage/projectSettings",
              children: [
                {
                  path: "/marketplace/manage/projectSettings",
                  name: "my_listings",
                  meta: { Auth: true, breadNumber: 1 },
                  component: (resolve) => require(["@/components/marketplace/manage/ProjectSettings.vue"], resolve),
                },
                {
                  path: "/marketplace/manage/projectSummary",
                  name: "applications",
                  meta: { Auth: true, breadNumber: 1 },
                  component: (resolve) => require(["@/components/marketplace/manage/ProjectSummary.vue"], resolve),
                },
                {
                  path: "/marketplace/manage/agreements",
                  name: "agreements",
                  meta: { Auth: true, breadNumber: 1 },
                  component: (resolve) => require(["@/components/marketplace/manage/Agreements.vue"], resolve),
                },
                {
                  path: "/marketplace/preview",
                  name: "preview",
                  meta: { Auth: true, breadNumber: 1 },
                  component: (resolve) => require(["@/components/marketplace/Preview.vue"], resolve),
                },
              ],
            },
            {
              path: "/marketplace/mine/projectSummary",
              name: "my_applications",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/marketplace/mine/ProjectSummary.vue"], resolve),
            },
            {
              path: "/marketplace/allProjects",
              name: "all_projects",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/marketplace/AllProjects.vue"], resolve),
            },
          ],
        },
        {
          path: "/marketplace/manage/agencySummary/:id",
          name: "applications",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/marketplace/manage/AgencySummary.vue"], resolve),
        },
        {
          path: "/marketplace/manage/applicationSummary/:id",
          name: "agency_list",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/marketplace/manage/ApplicationSummary.vue"], resolve),
        },
        {
          path: "/marketplace/manage/applications/:id",
          name: "applications",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/marketplace/manage/Applications.vue"], resolve),
        },
        {
          path: "/marketplace/mine/applications/:id",
          name: "applications",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/marketplace/mine/Applications.vue"], resolve),
        },
        {
          path: "/marketplace/applicationDetails/:id",
          name: "application_details",
          meta: { Auth: true, breadNumber: 3 },
          component: (resolve) => require(["@/components/marketplace/ApplicationDetails.vue"], resolve),
        },
        {
          path: "/marketplace/projectDetails/:id",
          name: "project_details",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/marketplace/ProjectDetails.vue"], resolve),
        },
        {
          path: "/marketplace/applyProcess/:id",
          name: "apply_process",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/marketplace/ApplyProcess.vue"], resolve),
        },
        //############### Marketplace 结束 ###############

        //############### 客户管理 开始 ###############
        {
          path: "/client_manage/clientDetail/:id",
          name: "add_new_client",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/CreateClient.vue"], resolve),
        },
        {
          path: "/client_manage/client-cdd/:id",
          name: "ClientCDD",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/CDDForm/index.vue"], resolve),
        },
        //
        {
          path: "/client_manage/allClients/clientDetail/:id",
          name: "client_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/client_manage/ClientDetail.vue"], resolve),
        },
        // {
        //     path: '/client_manage/allClientsBackup',
        //     name: 'all_clients',
        //     meta: { Auth: true },
        //     component: resolve => require(['@/components/client_manage/AllClients.vue'], resolve)
        // },
        {
          path: "/client_manage/allClients",
          name: "all_clients",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/AllClients.vue"], resolve),
        },
        {
          path: "/client_manage/contactLogs",
          name: "contact_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/ContactLogs.vue"], resolve),
        },
        {
          path: "/client_manage/contact_follow_up_report",
          name: "contact_follow_up_report",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/ContactFollowUpReport.vue"], resolve),
        },
        {
          path: "/client_manage/contact_meeting_report",
          name: "contact_meeting_report",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/ContactMeetingReport.vue"], resolve),
        },
        {
          path: "/client_manage/lead_generate_report",
          name: "lead_generate_report",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/ContactLeadGenerateReport.vue"], resolve),
        },
        {
          path: "/client_manage/campaigns/campaigns",
          name: "campaigns",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/campaigns/Campaigns.vue"], resolve),
        },
        {
          path: "/client_manage/campaign_summary",
          name: "CampaignSummary",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/campaigns/campaign_summary.vue"], resolve),
        },
        {
          path: "/client_manage/campaign_details",
          name: "CampaignDetails",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/campaigns/campaign_details.vue"], resolve),
        },
        {
          path: "/client_manage/campaign_preview",
          name: "CampaignPreview",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/campaigns/preview.vue"], resolve),
        },
        {
          path: "/client_manage/campaigns/campaign_overview",
          name: "campaign_overview_report",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/campaigns/campaignOverview.vue"], resolve),
        },
        {
          path: "/client_manage/create_campaigns",
          name: "CreateCampaigns",
          meta: { Auth: true },
          component: (resolve) =>
            require(["../../src/components/client_manage/campaigns/create_campaigns.vue"], resolve),
          redirect: "/create_campaigns/select_campaign_topic",
          children: [
            {
              path: "/client_manage/create_campaigns/select_campaign_topic",
              name: "SelectCampaignTopic",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/client_manage/campaigns/template/select_campaign_topic.vue"], resolve),
            },
            {
              path: "/client_manage/create_campaigns/select_recipients",
              name: "SelectRecipients",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/client_manage/campaigns/template/select_recipients.vue"], resolve),
            },
            {
              path: "/client_manage/create_campaigns/edit_email_contents",
              name: "EditEmailContents",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/client_manage/campaigns/template/edit_email_contents.vue"], resolve),
            },
            {
              path: "/client_manage/create_campaigns/review_and_send",
              name: "ReviewAndSend",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/client_manage/campaigns/template/review_and_send.vue"], resolve),
            },
          ],
        },
        {
          path: "/client_manage/create_campaigns/edit_email_contents/email_contents",
          name: "EmailContents",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/campaigns/email_contents.vue"], resolve),
        },
        {
          path: "/client_manage/clientTags",
          name: "contact_tags",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/client_manage/ContactTags.vue"], resolve),
        },
        {
          path: "/client_manage/platform_manage/importAgents",
          name: "import_agents",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/platform_manage/ImportContacts.vue"], resolve),
        },
        {
          path: "/client_manage/platform_manage/clientSync",
          name: "client_sync",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/platform_manage/ClientSync.vue"], resolve),
        },
        {
          path: "/client_manage/platform_manage/trashContacts",
          name: "trash_contact",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/platform_manage/TrashContacts.vue"], resolve),
        },
        //############### 客户管理 结束 ###############

        //############### 销售管理 开始 ###############
        {
          path: "/sale_manage/saleAdvice",
          name: "sales_advice",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/sale_manage/SaleAdvice.vue"], resolve),
        },
        {
          path: "/sale_manage/platform_manage/batchUploadSales",
          name: "batch_upload_sales",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/platform_manage/BatchUploadSales.vue"], resolve),
        },
        {
          path: "/sale_manage/platform_manage/importSales",
          name: "import_sales_and_contracts",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/platform_manage/ImportSales.vue"], resolve),
        },
        {
          path: "/sale_manage/platform_manage/archiveSales",
          name: "sale_archive",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/platform_manage/ArchiveSales.vue"], resolve),
        },
        {
          path: "/sale_manage/platform_manage/approveRequests",
          name: "request_approve",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/platform_manage/ApproveRequests.vue"], resolve),
          redirect: "/sale_manage/platform_manage/approveRequests/internalPending",
          children: [
            {
              path: "/sale_manage/platform_manage/approveRequests/internalPending",
              name: "internal_pending_requests",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/sale_manage/platform_manage/InternalPending.vue"], resolve),
            },
            {
              path: "/sale_manage/platform_manage/approveRequests/externalPending",
              name: "external_pending_requests",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/sale_manage/platform_manage/ExternalPending.vue"], resolve),
            },
          ],
        },
        {
          path: "/sale_manage/myRequests",
          name: "my_requests",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/MyRequests.vue"], resolve),
        },
        {
          path: "/sale_manage/awaitApproving",
          name: "await_approving",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AwaitApproving.vue"], resolve),
        },
        {
          path: "/sale_manage/awaitApprovingChannel",
          name: "await_approving_channel",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AwaitApprovingChannel.vue"], resolve),
        },
        {
          path: "/sale_manage/allReserved",
          name: "all_reserved",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AllReserved.vue"], resolve),
        },
        {
          path: "/sale_manage/allSales",
          name: "all_sales",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AllSales.vue"], resolve),
          redirect: "/sale_manage/allSales/allSales",
          children: [
            // {
            //   path: '/sale_manage/allSales/payDeposit',
            //   name: 'pay_deposit',
            //   meta: { Auth: true },
            //   component: resolve => require(['@/components/sale_manage/allSales/PayDeposit.vue'], resolve),
            // },
            {
              path: "/sale_manage/allSales/allReserved",
              name: "reserved",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/AllReserved.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/salesAdvice",
              name: "sales_advice",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/SalesAdvice.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/contractIssued",
              name: "contract_issued",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/ContractIssued.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/conditionalExchanged",
              name: "conditional_exchanged",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/ConditionalExchanged.vue"], resolve),
            },
            // {
            //   path: '/sale_manage/allSales/createInvoice',
            //   name: 'create_invoice',
            //   meta: { Auth: true },
            //   component: resolve => require(['@/components/sale_manage/allSales/CreateInvoice.vue'], resolve),
            // },
            // {
            //   path: '/sale_manage/allSales/refundDeposit',
            //   name: 'refund_deposit',
            //   meta: { Auth: true },
            //   component: resolve => require(['@/components/sale_manage/allSales/RefundDeposit.vue'], resolve),
            // },
            // pendingSettlement
            {
              path: "/sale_manage/allSales/pendingSettle",
              name: "pending_settle",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/PendingSettlement.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/allSales",
              name: "all_sales",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/Sales.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/unconditionalExchanged",
              name: "unconditional_exchanged",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/sale_manage/allSales/UnconditionalExchanged.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/allSettled",
              name: "settled",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/AllSettled.vue"], resolve),
            },
            {
              path: "/sale_manage/allSales/allCancelled",
              name: "all_cancelled",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/allSales/AllCancelled.vue"], resolve),
            },
          ],
        },
        {
          path: "/sale_manage/billbergiaSalesReport",
          name: "billbergia_sales_report",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/sale_manage/BillbergiaSalesReport.vue"], resolve),
        },
        {
          path: "/sale_manage/billbergiaAllSalesReport",
          name: "billbergia_all_sales_report",
          meta: { Auth: true, breadNumber: 3 },
          component: (resolve) => require(["@/components/sale_manage/BillbergiaAllSalesReport.vue"], resolve),
        },
        {
          path: "/sale_manage/creationhomesSalesReport",
          name: "creationhomes_sales_report",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) =>
            require(["@/components/sale_manage/CreationhomesSalesReport.vue"], resolve),
        },
        {
          path: "/sale_manage/kohamSalesReport",
          name: "koham_sales_report",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) =>
            require(["@/components/sale_manage/KohamSalesReport.vue"], resolve),
        },
        {
          path: "/sale_manage/allCancelled",
          name: "all_cancelled",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AllCancelled.vue"], resolve),
        },
        {
          path: "/sale_manage/allDeposits",
          name: "all_deposits",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AllDeposits.vue"], resolve),
          redirect: "/sale_manage/deposit/payDeposit",
          children: [
            {
              path: "/sale_manage/deposit/refundDeposit",
              name: "refund_deposit",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/deposit/RefundDeposit.vue"], resolve),
            },
            {
              path: "/sale_manage/deposit/payDeposit",
              name: "pay_deposit",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/sale_manage/deposit/PayDeposit.vue"], resolve),
            },
          ],
        },
        // {
        //     path: '/sale_manage/createInvoice',
        //     name: 'create_invoice',
        //     meta: { Auth: true },
        //     component: resolve => require(['@/components/sale_manage/CreateInvoice.vue'], resolve),
        // },
        {
          path: "/sale_manage/allInvoices",
          name: "all_invoices",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AllInvoices.vue"], resolve),
        },
        {
          path: "/sale_manage/allSettled",
          name: "all_settled",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/AllSettled.vue"], resolve),
        },
        {
          path: "/sale_manage/salesOffer",
          name: "sales_offer",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/sale_manage/SalesOffer.vue"], resolve),
        },
        //############### 销售管理 结束 ###############

        //############### 佣金管理 开始 ###############
        {
          path: "/commission/settingsList",
          name: "commission_settings_list",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/commission_manage/CommissionSettingsList.vue"], resolve),
        },
        {
          path: "/commission/settings",
          name: "commission_settings",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/commission_manage/CommissionSettings.vue"], resolve),
        },
        {
          path: "/commission/records",
          name: "commission_records",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/commission_manage/CommissionRecords.vue"], resolve),
        },
        {
          path: "/commission/overview",
          name: "commission_overview",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/commission_manage/CommissionOverview.vue"], resolve),
        },
        {
          path: "/commission/payeeList",
          name: "payee_list",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/commission_manage/PayeeList.vue"], resolve),
        },
        //############### 佣金管理 结束 ###############

        //############### 培训管理 开始 ###############
        {
          path: "/training/companyDoc/:id",
          name: "company_doc",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/training/Index.vue"], resolve),
        },
        {
          path: "/training/tutorial/:id",
          name: "tutorial",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/training/Index.vue"], resolve),
        },
        {
          path: "/training/platform/tutorial/:id",
          name: "agentweb_tutorial",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/training/Index.vue"], resolve),
        },
        //############### 培训管理 结束 ###############

        //############### 通知管理 开始 ###############
        {
          path: "/notification/addNotificationForAgentApp/:id",
          name: "add_notifications_agent_app",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/notification/NotificationDetailForAgentApp.vue"], resolve),
        },
        {
          path: "/notification/allNotificationsForAgentApp",
          name: "all_notifications_agent_app",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/notification/AllNotificationsForAgentApp.vue"], resolve),
        },
        {
          path: "/notification/notificationDetailForAgentApp/:id",
          name: "notification_detail_agent_app",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/notification/NotificationDetailForAgentApp.vue"], resolve),
        },
        {
          path: "/notification/BroadcastDetailForAgentApp/:id",
          name: "broadcast_detail_agent_app",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/notification/BroadcastDetailForAgentApp.vue"], resolve),
        },
        {
          path: "/notification/BroadcastForAgentApp",
          name: "broadcast_agent_app",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/notification/BroadcastForAgentApp.vue"], resolve),
        },
        //############### 通知管理 结束 ###############

        //############### 基本信息管理 开始 ###############
        {
          path: "/master_manage/agencies",
          name: "agency",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/Agencies.vue"], resolve),
        },
        {
          path: "/master_manage/agencies/agencyDetail/:id",
          name: "agency_detail",
          meta: { Auth: true, keepAlive: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/AgencyDetail.vue"], resolve),
        },
        {
          path: "/master_manage/agencies/agencyDetailPreview/:id",
          name: "agency_detail",
          meta: { Auth: true, keepAlive: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/AgencyDetailPreview.vue"], resolve),
        },
        {
          path: "/master_manage/agencies/addAgency",
          name: "add_new_agency",
          meta: { Auth: true, keepAlive: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/AddAgency.vue"], resolve),
        },
        {
          path: "/master_manage/agencyDetailPreview/:id",
          name: "own_agency",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/AgencyDetailPreview.vue"], resolve),
        },
        {
          path: "/master_manage/agencyDetail/:id",
          name: "agency_detail",
          meta: { Auth: true, keepAlive: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/AgencyDetail.vue"], resolve),
        },
        {
          path: "/master_manage/vendors",
          name: "vendors",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/Vendors.vue"], resolve),
        },
        {
          path: "/master_manage/vendors/vendorDetail/:id",
          name: "vendor_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/VendorDetail.vue"], resolve),
        },
        {
          path: "/master_manage/builders",
          name: "all_builders",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/Builders.vue"], resolve),
        },
        {
          path: "/master_manage/solicitors",
          name: "all_solicitors",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/Solicitors.vue"], resolve),
        },
        {
          path: "/master_manage/solicitorFirms",
          name: "solicitor_firms",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/SolicitorFirms.vue"], resolve),
        },
        {
          path: "/master_manage/brokers",
          name: "all_brokers",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/Brokers.vue"], resolve),
        },
        {
          path: "/master_manage/brokerFirms",
          name: "broker_firms",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/BrokerFirms.vue"], resolve),
        },
        {
          path: "/master_manage/brokerFirms/brokerFirmDetail/:id",
          name: "broker_firm_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/BrokerFirmDetail.vue"], resolve),
        },
        //############### 基本信息管理 结束 ###############

        //############### 团队管理 开始 ###############
        {
          path: "/teams_manage/departments",
          name: "departments",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/department/Departments.vue"], resolve),
        },
        {
          path: "/teams_manage/departments/agreementDetail/:id",
          name: "agreement_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) =>
            require(["@/components/master_manage/department/common/AgreementDetail.vue"], resolve),
        },
        {
          path: "/teams_manage/departments/agentDetail",
          name: "agent_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/AgentDetail.vue"], resolve),
        },
        {
          path: "/teams_manage/agents",
          name: "members",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/Agents.vue"], resolve),
        },
        {
          path: "/teams_manage/agents/reports/:id",
          name: "reports",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/Reports.vue"], resolve),
        },
        {
          path: "/teams_manage/agents/agentDetail",
          name: "agent_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/master_manage/AgentDetail.vue"], resolve),
        },
        {
          path: "/teams_manage/importExternalID",
          name: "import_externalid",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/ImportExternalID.vue"], resolve),
        },
        {
          path: "/teams_manage/platform_manage/moveAgent",
          name: "migrate_agent",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/platform_manage/MoveAgent.vue"], resolve),
        },
        {
          path: "/teams_manage/platform_manage/findAgent",
          name: "find_agent",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/platform_manage/FindAgent.vue"], resolve),
        },
        {
          path: "/teams_manage/unlockMembers",
          name: "unlock_members",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/master_manage/UnlockMembers.vue"], resolve),
        },
        //############### 团队管理 结束 ###############

        //############### 系统设置 开始 ###############
        {
          path: "/system_setting/languages",
          name: "languages",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/Languages.vue"], resolve),
        },
        {
          path: "/system_setting/countries",
          name: "countries",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/Countries.vue"], resolve),
        },
        {
          path: "/system_setting/optionValues",
          name: "option_values",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/OptionValues.vue"], resolve),
        },
        {
          path: "/system_setting/mailFormatDetail/:id",
          name: "mail_format_detail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/system_setting/MailFormatDetail.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/approval",
          name: "approval",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/Approval.vue"], resolve),
          redirect: "/system_setting/back_end/approval/teamBaseSetting",
          children: [
            {
              path: "/system_setting/back_end/approval/teamBaseSetting",
              name: "team_base_setting",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/system_setting/back_end/team_approval/TeamBaseSetting.vue"], resolve),
            },
            {
              path: "/system_setting/back_end/approval/projectBaseSetting",
              name: "project_base_setting",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/system_setting/back_end/project_approval/ProjectBaseSetting.vue"], resolve),
            },
            {
              path: "/system_setting/back_end/approval/shareProjectSetting",
              name: "share_project_setting",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/system_setting/back_end/ShareProjectSetting.vue"], resolve),
            },
          ],
        },
        {
          path: "/system_setting/back_end/resources",
          name: "resources",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/Resources.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/functions",
          name: "functions",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/Functions.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/roles",
          name: "back_end_roles",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/Roles.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/roles2",
          name: "back_end_roles2",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/Roles2.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/users",
          name: "back_end_users",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/Users.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/mailFormat",
          name: "mail_format",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/MailFormat.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/mailHost",
          name: "mail_host",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/MailHost.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/salesResources",
          name: "sales_resources",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/SalesResources.vue"], resolve),
        },
        {
          path: "/system_setting/aiPrompt",
          name: "ai_prompt",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/AIPrompt.vue"], resolve),
        },
        {
          path: "/system_setting/back_end/otherSetting",
          name: "other_setting",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/back_end/OtherSetting.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/taskSetting",
          name: "task_setting",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/TaskSetting.vue"], resolve),
        },
        {
          path: "/system_setting/agencySetting",
          name: "agency_setting",
          meta: { Auth: true, breadNumber: 1},
          component: (resolve) => require(["@/components/system_setting/AgencySetting.vue"], resolve),
        },
        {
          path: "/system_setting/agencySetting/authAuditTrail",
          name: "audit_trail",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/system_setting/AuthAuditTrail.vue"], resolve),
        },
        {
          path: "/system_setting/email_template_settings",
          name: "email_template_settings",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/EmailTemplateSettings.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/functions",
          name: "functions",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/Functions.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/roles",
          name: "app_agent_roles",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/Roles.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/roles2",
          name: "app_agent_roles2",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/Roles2.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/salesResources",
          name: "sales_resources",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/SalesResources.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/users",
          name: "app_agent_users",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/Users.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/resources",
          name: "resources2",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/Resources.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/mailFormat",
          name: "app_agent_mail_format",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/MailFormat.vue"], resolve),
        },
        {
          path: "/system_setting/app_agent/otherSetting",
          name: "app_agent_other_setting",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/app_agent/OtherSetting.vue"], resolve),
        },
        {
          path: "/system_setting/corporateWebsite",
          name: "corporate_website",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/CorporateWebsite.vue"], resolve),
        },
        {
          path: "/system_setting/automationSetting",
          name: "automation_settings",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/system_setting/automation/Index.vue"], resolve),
        },
        {
          path: "/system_setting/automationSetting/activityLog",
          name: "automation_activity_log",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/system_setting/automation/ActivityLog.vue"], resolve),
        },
        {
          path: "/system_setting/arcWebsite",
          name: "arc_website",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/ArcWebsite.vue"], resolve),
        },
        {
          path: "/system_setting/campaignHost",
          name: "campaign_host",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/CampaignHost/Index.vue"], resolve),
          redirect: "/system_setting/campaignHost/hostSetting",
          children: [
            {
              path: "/system_setting/campaignHost/hostSetting",
              name: "campaignHostSetting",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/system_setting/CampaignHost/HostSetting.vue"], resolve),
            },
            {
              path: "/system_setting/campaignHost/usageStatistics",
              name: "campaignHostUsage",
              meta: { Auth: true },
              component: (resolve) =>
                require(["@/components/system_setting/CampaignHost/usageStatistics.vue"], resolve),
            },
          ],
        },
        {
          path: "/system_setting/mailHosts",
          name: "mail_hosts",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/MailHosts.vue"], resolve),
        },
        {
          path: "/system_setting/amlSetting",
          name: "aml_settings",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/system_setting/AmlSetting.vue"], resolve),
        },
        //############### 系统设置 结束 ###############

        //############### 日志管理 开始 ###############
        {
          path: "/sync_log/allSyncLog",
          name: "sync_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/admin_logs/sync_logs/AllSyncLog.vue"], resolve),
          redirect: "/sync_log/allSyncLog/saleSyncLog",
          children: [
            {
              path: "/sync_log/allSyncLog/departmentSyncLog",
              name: "team_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/DepartmentSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/saleSyncLog",
              name: "sale_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/SaleSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/projectSyncLog",
              name: "project_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/ProjectSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/propertySyncLog",
              name: "property_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/PropertySyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/clientSyncLog",
              name: "client_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/ClientSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/meetingSyncLog",
              name: "meeting_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/MeetingSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/agencyProjectSyncLog",
              name: "project_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/AgencyProjectSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/reaSyncLog",
              name: "rea_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/ReaSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/domainSyncLog",
              name: "domain_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/DomainSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/agentboxSyncLog",
              name: "agentbox_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/AgentboxSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/activeCampaignSyncLog",
              name: "activecampaign_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/ActiveCampaignSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/frameworkSyncLog",
              name: "framework_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/FrameworkSyncLog.vue"], resolve),
            },
            {
              path: "/sync_log/allSyncLog/crossubSyncLog",
              name: "crossub_sync_log",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/sync_logs/CrossubSyncLog.vue"], resolve),
            },
          ],
        },
        {
          path: "/task_log/allTaskLog",
          name: "task_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/admin_logs/task_logs/AllTaskLog.vue"], resolve),
          redirect: "/task_log/allTaskLog/agentTaskLog",
          children: [
            {
              path: "/task_log/allTaskLog/agentTaskLog",
              name: "agent_task_logs",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/task_logs/AgentTaskLog.vue"], resolve),
            },
            {
              path: "/task_log/allTaskLog/adminTaskLog",
              name: "admin_task_logs",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/admin_logs/task_logs/AdminTaskLog.vue"], resolve),
            },
          ],
        },
        {
          path: "/admin_logs/operationLogs",
          name: "operation_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/admin_logs/OperationLogs.vue"], resolve),
        },
        {
          path: "/admin_logs/emailErrorLogs",
          name: "email_error_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/admin_logs/error_message/MailErrorHistory.vue"], resolve),
        },
        {
          path: "/admin_logs/bookingDemoLogs",
          name: "booking_demo_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/admin_logs/BookingDemoLogs.vue"], resolve),
        },
        {
          path: "/admin_logs/currencyRateLogs",
          name: "currency_rate_logs",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/admin_logs/CurrencyRateLogs.vue"], resolve),
        },
        //############### 日志管理 结束 ###############

        //############### 第三方集成管理 开始 ###############
        {
          path: "/integrations/rea",
          name: "rea",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/rea/REA.vue"], resolve),
          redirect: "/integrations/rea/leadCapture",
          children: [
            {
              path: "leadCapture",
              name: "lead_capture",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/rea/LeadCapture.vue"], resolve),
            },
            {
              path: "listingMapping",
              name: "listing_mapping",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/rea/ListingMapping.vue"], resolve),
            },
            {
              path: "leadRecords",
              name: "lead_records",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/rea/LeadRecords.vue"], resolve),
            },
            {
              path: "listingPush",
              name: "rea",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/integrations/rea/ListingPush.vue"], resolve),
            },
          ],
        },        
        {
          path: "/integrations/rea/editlisting",
          name: "edit_listing",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/integrations/rea/EditListing.vue"], resolve),
        },
        {
          path: "/integrations/rea/pushhistory",
          name: "view_history",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/integrations/rea/PushHistory.vue"], resolve),
        },
        {
          path: "/integrations/homely",
          name: "homely",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/integrations/homely/Homely.vue"], resolve),
        },
        {
          path: "/integrations/homely/pushhistory",
          name: "push_history",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/integrations/homely/PushHistory.vue"], resolve),
        },
        {
          path: "/integrations/mailchimp",
          name: "mailchimp",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/Mailchimp.vue"], resolve),
        },
        {
          path: "/integrations/activeCampaign",
          name: "activecampaign",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/ActiveCampaign.vue"], resolve),
        },
        {
          path: "/integrations/agentbox",
          name: "agentbox",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/agentbox/Index.vue"], resolve),
          redirect: "/integrations/agentbox/leadCapture",
          children: [
            {
              path: "/integrations/agentbox/leadCapture",
              name: "leadCapture",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/agentbox/LeadCapture.vue"], resolve),
            },
            {
              path: "/integrations/agentbox/listingMapping",
              name: "listingMapping",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/agentbox/ListingMapping.vue"], resolve),
            },
          ],
        },
        {
          path: "/integrations/crossub",
          name: "crossub",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/integrations/crossub/Crossub.vue"], resolve),
        },
        {
          path: "/integrations/crossub/rentalList",
          name: "rental_list",
          meta: { Auth: true, breadNumber: 2 },
          component: (resolve) => require(["@/components/integrations/crossub/RentalList.vue"], resolve),
        },
        // {
        //   path: "/integrations/domain",
        //   name: "domain",
        //   meta: { Auth: true },
        //   component: (resolve) => require(["@/components/integrations/Domain.vue"], resolve),
        // },
        {
          path: "/integrations/domain",
          name: "domain",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/domain/index.vue"], resolve),
          redirect: "/integrations/domain/leadCapture",
          children: [
            {
              path: "leadCapture",
              name: "lead_capture",
              meta: { Auth: true },
              // component: (resolve) => require(["@/components/integrations/domain/LeadCapture.vue"], resolve),              
              component: (resolve) => require(["@/components/integrations/Domain.vue"], resolve),
            },
            {
              path: "listingMapping",
              name: "listing_mapping",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/domain/ListingMapping.vue"], resolve),
            },
            {
              path: "leadRecords",
              name: "lead_records",
              meta: { Auth: true },
              component: (resolve) => require(["@/components/integrations/domain/LeadRecords.vue"], resolve),
            },
            {
              path: "listingPush",
              name: "portal_push",
              meta: { Auth: true, breadNumber: 1 },
              component: (resolve) => require(["@/components/integrations/domain/ListingPush.vue"], resolve),
            },
          ],
        },   
        {
          path: "/integrations/framework",
          name: "framework",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/Framework.vue"], resolve),
        },
        {
          path: "/integrations/webhook",
          name: "webhook",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/integrations/Webhook.vue"], resolve),
        },
        {
          path: "/integrations/firstAml",
          name: "firstaml",
          meta: { Auth: true, breadNumber: 1 },
          component: (resolve) => require(["@/components/integrations/firstaml/FirstAml.vue"], resolve),
        },
        //############### 第三方集成管理 结束 ###############

        //############### 导出管理 开始 ###############
        {
          path: "/export_data/exportData",
          name: "export_data",
          meta: { Auth: true },
          component: (resolve) => require(["@/components/export_data/ExportData.vue"], resolve),
        },
        //############### 导出管理 结束 ###############
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js